<template>
  <div class="cgs-worksheet-updateRow">
    <div class="cgs-updateRow-header">
      <van-nav-bar :border="true">
        <template #left>
          <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
        </template>
        <!-- <template #right v-if="dataChanged && updateable">
          <span @click="saveRow">保存</span>
        </template> -->
      </van-nav-bar>
    </div>
    <div class="cgs-updateRow-content">
      <v-form-render ref="vFormRef" :form-json="formJson" :form-data="formData" :option-data="optionData"
        @formChange="onFormDataChange" class="vFormContent"></v-form-render>
    </div>
    <!-- <van-form>
            <van-field
                v-model="list.textarea107575"
                name="textarea"
                label="textarea"
                placeholder="textarea"
            />
            <van-field
                v-model="list.input48391"
                name="input"
                label="input"
                placeholder="input"
            />
            <van-field name="uploader" label="文件上传">
            <template #input>
                <van-uploader v-model="list.pictureupload73802" />
            </template>
            </van-field>
            <div style="margin: 16px;display: flex;justify-content: center;">
                <van-button round type="primary">取消</van-button>
                <van-button round type="info" @click="updata">修改</van-button>
            </div>
        </van-form> -->
  </div>
</template>

<script>
  import {
    NavBar,
    Button
  } from "vant";
  import {
    getWorksheetInfo,
    getRow,
    updateRow
  } from "@/api/message";
  import {
    getUserAuthority
  } from "@/util/author";
  import "@/assets/style/css/vForm.css";
  export default {
    components: {
      vanNavBar: NavBar,
      vanButton: Button,
    },
    data() {
      return {
        worksheetDetail: {},
        rowDetail: {},
        formJson: {},
        formData: {},
        optionData: {},
        dataChanged: false
      };
    },
    created() {
      window.vformUploadUrlPrefix = process.env.VUE_APP_BASEURL;
    },
    mounted() {
      this.init();
    },
    computed: {
      userId: {
        get() {
          let userAuthority = getUserAuthority();
          return userAuthority.userId;
        },
        set() {},
      },
      worksheetId: {
        get() {
          return this.$route.params.tableId;
        },
        set() {},
      },
      rowId: {
        get() {
          return this.$route.params.rowId;
        },
        set() {},
      },
    },
    methods: {
      async init() {
        // this.wholeLoading = true
        try {
          let worksheetResult = await getWorksheetInfo(this.worksheetId);
          let rowRestule = await getRow(this.worksheetId, this.rowId);

          this.worksheetDetail = worksheetResult.data;
          this.rowDetail = rowRestule.data;
          if ("config" in this.worksheetDetail) {
            let config =
              this.worksheetDetail.config === "" ?
              [] :
              JSON.parse(this.worksheetDetail.config);
            config.formConfig.labelPosition = "top";
            this.$refs.vFormRef.setFormJson(config);
            this.$refs.vFormRef.setFormData(this.rowDetail);
            setTimeout(() => {
              this.$refs.vFormRef.disableForm()
            }, 100)
          }
        } catch (e) {
          console.error(e);
        } finally {
          // this.wholeLoading = false
        }
      },
      goBack() {
        this.$router.go(-1);
      },
      onFormDataChange() {
        this.dataChanged = true;
      },
      async saveRow() {
        this.$Toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        let formData = await this.$refs.vFormRef.getFormData();
        let result = await updateRow({
          worksheetId: this.worksheetId,
          rowId: this.rowId,
          data: formData,
        });
        if (result) {
          this.$Notify({
            type: "success",
            message: "提交成功"
          });
          // this.goBack()
        } else {
          this.$Notify({
            type: "danger",
            message: "提交失败"
          });
        }
        this.dataChanged = false;
        this.$Toast.clear();
      }
    },
  };
  // import { Button,NavBar } from 'vant';
  // import { Messagerows,MessageUpdata } from '@/api/message';
  // export default {
  //     components: {
  //         vanNavBar: NavBar,
  //         vanButton: Button,
  //     },
  //     data () {
  //         return {
  //             list:{},
  //             uplist:{
  //                 input104934:'',
  //                 textarea55357:'',
  //                 pictureupload46823:'',
  //             },
  //         }
  //     },
  //     computed: {
  //         worksheetId: {
  //         get() {
  //             return this.$route.params.tableId;
  //         },
  //         set() {},
  //         },
  //         rowId: {
  //         get() {
  //             return this.$route.params.rowId;
  //         },
  //         set() {},
  //         },
  //     },
  //     methods: {
  //         async getrow(){
  //             let getlist = await Messagerows(this.worksheetId,this.rowId)
  //             this.list = getlist.data
  //         },
  //         async updata(){
  //             this.uplist.input104934 = this.list.input48391
  //             this.uplist.textarea55357 = this.list.textarea107575
  //             this.uplist.pictureupload46823 = this.list.pictureupload73802
  //             let result =  await MessageUpdata({worksheetId:this.worksheetId,rowId:this.rowId,data:this.uplist})
  //             if(result){
  //                 this.$message.success('修改成功！');
  //             } else {
  //                 this.$message.error('修改失败！');
  //             }
  //             this.getrow()
  //         }
  //     },
  //     created () {
  //         this.getrow()
  //     }
  // }
</script>

<style scoped>
  .cgs-worksheet-updateRow {
    /* background: #f5f5f5; */
    display: flex;
    flex-direction: column;
  }

  /* .cgs-appPage-header{
    color: #fff;
} */
  .cgs-updateRow-content {
    /* flex-grow: 1; */
    flex: 1;
    overflow: hidden;
    padding: 10px;
    overflow-y: auto;
  }
</style>